import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository"

const resource = "/bank";
export default {

  getBankIFSCDetails(ifscCode) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/${ifscCode}/bankDetails`);
  }
}